import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ru');

  useEffect(() => {
    const saved = localStorage.getItem('language');
    if (saved && ['ru', 'kk', 'en'].includes(saved)) {
      setLanguage(saved);
    }
  }, []);

  const changeLanguage = (lang) => {
    if (['ru', 'kk', 'en'].includes(lang)) {
      setLanguage(lang);
      localStorage.setItem('language', lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const translations = {
  'header.signIn': {
    ru: 'Вход',
    kk: 'Кіру',
    en: 'Sign In'
  },
  'header.signUp': {
    ru: 'Регистрация',
    kk: 'Тіркеу',
    en: 'Sign Up'
  },
  'header.signOut': {
    ru: 'Выход',
    kk: 'Шығу',
    en: 'Sign Out'
  },
  'nav.home': {
    ru: 'Главная',
    kk: 'Басты',
    en: 'Home'
  },
  'nav.analyzer': {
    ru: 'Анализатор',
    kk: 'Талдау',
    en: 'Analyzer'
  },
  'nav.ioTypes': {
    ru: 'Типы ИО',
    kk: 'ИО түрлері',
    en: 'IO Types'
  },
  'nav.thesaurus': {
    ru: 'Тезаурус',
    kk: 'Тезаурус',
    en: 'Thesaurus'
  },
  'nav.statistics': {
    ru: 'Статистика',
    kk: 'Статистика',
    en: 'Statistics'
  },
  'nav.admin': {
    ru: 'Админ',
    kk: 'Админ',
    en: 'Admin'
  }
};

export const t = (key, language = 'ru') => {
  const keys = key.split('.');
  let obj = translations;
  
  for (let k of keys) {
    if (obj && obj[k]) {
      obj = obj[k];
    } else {
      return key;
    }
  }
  
  return typeof obj === 'object' ? obj[language] || key : obj;
};
